import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../api/client";
import { Logo, IconCheck, IconAlert, IconLoader } from "../components/Icons";
import LanguageFlags from "../components/LanguageFlags";

export default function VerifyEmail() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const loc = useLocation();
  const token = new URLSearchParams(loc.search).get("token");
  const [status, setStatus] = useState<"verifying" | "ok" | "error">("verifying");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMsg(t("auth.missingToken"));
      return;
    }
    void (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        setStatus("ok");
        setMsg(t("auth.emailVerified"));
        setTimeout(() => nav("/login"), 2500);
      } catch (e: any) {
        setStatus("error");
        setMsg(e?.response?.data?.detail || t("auth.verifyFailed"));
      }
    })();
  }, [token, t]);

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "var(--bg)", position: "relative", overflow: "hidden",
    }}>
      <div style={{ position: "fixed", top: 16, right: 16, zIndex: 10 }}>
        <LanguageFlags />
      </div>
      <div style={{
        position: "absolute", top: "-20%", left: "-10%",
        width: 600, height: 600, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(255,183,0,0.08) 0%, transparent 70%)",
        filter: "blur(60px)",
      }} />

      <div style={{ position: "relative", textAlign: "center", maxWidth: 420, padding: 24 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 32 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <Logo size={44} />
            <span style={{
              fontSize: 26, fontWeight: 800, letterSpacing: -0.5,
              background: "var(--gradient-sunset)",
              WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
            }}>LuigiPOS</span>
          </div>
        </div>

        <div className="card card-glow" style={{ padding: 40 }}>
          {status === "verifying" && (
            <>
              <IconLoader size={48} className="muted" style={{ margin: "0 auto" }} />
              <h2 style={{ marginTop: 20, fontSize: 18, fontWeight: 600 }}>{t("auth.verifying")}</h2>
            </>
          )}
          {status === "ok" && (
            <>
              <div style={{
                width: 64, height: 64, borderRadius: "50%", margin: "0 auto",
                background: "var(--green-dim)", display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <IconCheck size={32} style={{ color: "var(--green)" }} />
              </div>
              <h2 style={{ marginTop: 20, fontSize: 18, fontWeight: 600, color: "var(--green)" }}>{msg}</h2>
              <p style={{ color: "var(--muted)", marginTop: 8, fontSize: 14 }}>{t("auth.redirecting")}</p>
            </>
          )}
          {status === "error" && (
            <>
              <div style={{
                width: 64, height: 64, borderRadius: "50%", margin: "0 auto",
                background: "var(--red-dim)", display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <IconAlert size={32} style={{ color: "var(--red)" }} />
              </div>
              <h2 style={{ marginTop: 20, fontSize: 18, fontWeight: 600, color: "var(--red)" }}>{t("auth.verifyFailedTitle")}</h2>
              <p style={{ color: "var(--muted)", marginTop: 8, fontSize: 14 }}>{msg}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
